module.exports = __webpack_public_path__ + "img/Mauritania.6a8a62e0.svg";